function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import hoistNonReactStatics from "hoist-non-react-statics";
import RecaptchaContext from "./Context";
export function withGoogleReCaptcha(Component) {
  const WithGoogleReCaptchaWrapper = props => React.createElement(RecaptchaContext.Consumer, null, contextValue => React.createElement(Component, _extends({}, props, {
    reCaptchaConfig: contextValue
  })));

  WithGoogleReCaptchaWrapper.displayName = `withReCaptcha(${Component.displayName || Component.name || "Component"})`;
  hoistNonReactStatics(WithGoogleReCaptchaWrapper, Component);
  return WithGoogleReCaptchaWrapper;
}